import { translate } from "../../../util/translate"

export const hausefulInvoiceHeaders = [
  {
    text: translate['hausefulInvoices.headers.hausefulValue'],
    value: 'hauseful_value',
    sortable: false,
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    sortable: false,
  },
  {
    text: translate['hausefulInvoices.headers.file'],
    value: 'file_response',
    align: 'center',
    width: 80,
    sortable: false,
  }
]

export const hostInvoiceHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host',
    sortable: false,
  },
  {
    text: translate['hausefulInvoices.headers.totalValue'],
    value: 'total',
    sortable: false,
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    sortable: false,
  },
  {
    text: translate['hausefulInvoices.headers.file'],
    value: 'file_response',
    align: 'center',
    width: 80,
    sortable: false,
  }
]
